<button *ngIf="showScrollButton" class="scroll-button" (click)="scrollToTop()">
    <i class="bi bi-chevron-up"></i>
  </button>
